import React from 'react'
import { AddNewPayeeButtonProps } from '../../../types'
import { Panel } from '@cjdev-internal/visual-stack-x/Panel'
import { FormPageBlock } from '@cjdev-internal/visual-stack-x/FormPageLayout'
import { Button } from '@cjdev-internal/visual-stack-x/Button'


const AddNewPayeeButton = ({showPayeeForm, intl}: AddNewPayeeButtonProps) => {
  return (
    <Panel>
      <FormPageBlock gap="medium" align="center">
        <Button type="primary" onClick={showPayeeForm}>
          {intl.addNewPayeeButton.add}
        </Button>
      </FormPageBlock>
    </Panel>

  )
}

export default AddNewPayeeButton;